import {
  REWARD_CARD_TYPES,
  REWARD_TYPES
} from '@/utils/constants/rewardsConstants';
import {
  useQuotaValidation,
  useLimitPerStoreValidation,
  useQuotaDigitalCardValidation,
  useQuotaPhysicalCardValidation,
  useLimitPerStoreDigitalCardValidation,
  useLimitPerStorePhysicalCardValidation,
  useMaxQtyPerOrderValidation
} from '../../validations';

export const useAdditionalAttributesLogic = (props) => {
  const {formData, handleFormChange, handleValidation} = props;

  const {onChange: validateQuota} = useQuotaValidation();
  const {onChange: validateLimitPerStore} = useLimitPerStoreValidation();
  const {onChange: validateMaxQtyPerOrder} = useMaxQtyPerOrderValidation();
  const {onChange: validateQuotaDigitalCard} = useQuotaDigitalCardValidation();
  const {onChange: validateQuotaPhysicalCard} =
    useQuotaPhysicalCardValidation();
  const {onChange: validateLimitPerStoreDigitalCard} =
    useLimitPerStoreDigitalCardValidation();
  const {onChange: validateLimitPerStorePhysicalCard} =
    useLimitPerStorePhysicalCardValidation();

  const cleanQuotaFields = (isUnlimited) => {
    if (isUnlimited) {
      handleFormChange('quota', '');
      handleLeftOverInventoryChange('Unlimited');
    } else {
      handleLeftOverInventoryChange('');
    }
  };

  const cleanDigitalAndPhysicalInventoryFields = (isUnlimited) => {
    if (isUnlimited) {
      handleFormChange('quotaDigitalCard', '');
      handleFormChange('quotaPhysicalCard', '');
      handleLeftOverInventoryDigitalCardChange('Unlimited');
      handleLeftOverInventoryPhysicalCardChange('Unlimited');
    } else {
      handleLeftOverInventoryDigitalCardChange('');
      handleLeftOverInventoryPhysicalCardChange('');
    }
  };

  const handleQuotaChange = (value) => {
    const error = validateQuota(value);
    handleFormChange('quota', value);
    handleValidation('quota', error);
    handleLeftOverInventoryChange(value);
  };

  const handleLeftOverInventoryChange = (value) => {
    handleFormChange('leftOverInventory', value);
  };

  const handleLimitPerStoreChange = (value) => {
    const error = validateLimitPerStore(value);
    handleFormChange('limitPerStore', value);
    handleValidation('limitPerStore', error);
  };

  const handleMaxQtyPerOrderChange = (value) => {
    const error = validateMaxQtyPerOrder(value);
    handleFormChange('maxQtyPerOrder', value);
    handleValidation('maxQtyPerOrder', error);
  };

  const handleQuotaDigitalCardChange = (value) => {
    const error = validateQuotaDigitalCard(value);
    handleLeftOverInventoryDigitalCardChange(value);
    handleFormChange('quotaDigitalCard', value);
    handleValidation('quotaDigitalCard', error);
  };

  const handleLeftOverInventoryDigitalCardChange = (value) => {
    handleFormChange('leftOverInventoryDigitalCard', value);
  };

  const handleLimitPerStoreDigitalCardChange = (value) => {
    const error = validateLimitPerStoreDigitalCard(value);
    handleValidation('limitPerStoreDigitalCard', error);
    handleFormChange('limitPerStoreDigitalCard', value);
  };

  const handleQuotaPhysicalCardChange = (value) => {
    const error = validateQuotaPhysicalCard(value);
    handleLeftOverInventoryPhysicalCardChange(value);
    handleFormChange('quotaPhysicalCard', value);
    handleValidation('quotaPhysicalCard', error);
  };

  const handleLeftOverInventoryPhysicalCardChange = (value) => {
    handleFormChange('leftOverInventoryPhysicalCard', value);
  };

  const handleLimitPerStorePhysicalCardChange = (value) => {
    const error = validateLimitPerStorePhysicalCard(value);
    handleValidation('limitPerStorePhysicalCard', error);
    handleFormChange('limitPerStorePhysicalCard', value);
  };

  // Handlers for ToggleRow
  const handleDisplayOutOfStockChange = (value) => {
    handleFormChange('displayOutOfStock', value);
  };

  const handleUnlimitedInventoryChange = (value) => {
    if (
      formData?.cardType === REWARD_CARD_TYPES.Both &&
      formData?.rewardType === REWARD_TYPES.VISA_CARD
    ) {
      cleanDigitalAndPhysicalInventoryFields(value);
    } else {
      cleanQuotaFields(value);
    }
    handleFormChange('unlimitedInventory', value);
  };

  const handleInStockChange = (value) => {
    handleFormChange('inStock', value);
  };

  return {
    handleQuotaChange,
    handleLeftOverInventoryChange,
    handleLimitPerStoreChange,
    handleMaxQtyPerOrderChange,
    handleQuotaDigitalCardChange,
    handleLeftOverInventoryDigitalCardChange,
    handleLimitPerStoreDigitalCardChange,
    handleQuotaPhysicalCardChange,
    handleLeftOverInventoryPhysicalCardChange,
    handleLimitPerStorePhysicalCardChange,
    handleDisplayOutOfStockChange,
    handleUnlimitedInventoryChange,
    handleInStockChange
  };
};
